import { httpService } from '~/Services/Service';

// Backend: simula-comissao-cobranca/* (RoutePrefix sem "api/" — APIBASE não prepende api/).
// Payload snake_case (serialização global da WebAPI). /simular é POST + body (payload pesado:
// período, filtros, faixas progressivas, valores fixos e modos).
const BASE = '/simula-comissao-cobranca';

// Lookup de cobradores (prestadores de serviço ativos tipo 1-5).
export const listarCobradores = () => httpService.get(`${BASE}/cobradores`);

// Lookup de empreendimentos/famílias ativas.
export const listarEmpreendimentos = () =>
  httpService.get(`${BASE}/empreendimentos`);

// Executa a simulação. body: data_inicio, data_fim, dias, cobrador_id, familia_id,
// analitico, comissao_por_percentual, calcular_por_faixa, faixas[], valor_fixo_rfg/res/rfp.
export const simular = body => httpService.post(`${BASE}/simular`, body);
